
import { defineComponent, ref } from 'vue';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { IToaXeResponseBase } from '@/core/interfaces/ApiResponses';
import { setBreadcrumbLinks } from '@/core/helpers/breadcrumb';
import { swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { TOA_XE } from '@/core/constants/permissions';

import Can from '@/components/Can.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import PageContentSection from '@/layout/_shared/PageContentSection.vue';
import ToaXeService from '@/core/services/ToaXe.service';
import BaseLink from '@/components/shared/base-link/BaseLink.vue';

export default defineComponent({
  name: 'toa-xe-chi-tiet',

  components: {
    BaseLink,
    ButtonCustom,
    Can,
    ConfirmationDialog,
    DivCol,
    DivRow,
    LabelCustom,
    PageContentBase,
    PageContentSection,
  },

  data() {
    return {
      removeItemDialogDisplay: false,
    };
  },

  setup() {
    const { goBack, push, id } = useRouterCustom();
    const { moment } = useDateTime();
    const { ButtonTypeColors, ButtonsType } = useButtonCustom();

    const toaXe = ref<IToaXeResponseBase | null>(null);

    return {
      TOA_XE,
      toaXeId: id,
      toaXe,
      moment,
      goBack,
      push,
      ButtonTypeColors,
      ButtonsType,
    };
  },

  async mounted() {
    setBreadcrumbLinks([
      {
        text: 'Toa xe',
        routeData: {
          name: 'danh-sach-toa-xe',
        },
      },
      {
        text: 'Chi tiết',
      },
    ]);

    try {
      const {
        data: { data: res },
      } = await ToaXeService.get(this.toaXeId);

      this.toaXe = res;
      document.title = `${res.ten_toa_xe} - Toa xe - Đường sắt Hà Nội `;
    } catch (e) {
      await swalErrNotification(e, 'Có lỗi xảy ra, không thể xóa toa xe này');
    }
  },

  methods: {
    async confirmDelete() {
      this.removeItemDialogDisplay = false;

      try {
        await ToaXeService.delete(this.toaXeId);
        await swalNotification('Xóa thành công', 'success');
        await this.push('/quan-ly/toa-xe/danh-sach');
      } catch (error) {
        await swalErrNotification(
          error,
          'Có lỗi xảy ra, không thể xóa toa xe này'
        );
      }
    },
  },
});
